import { useTranslation } from 'react-i18next';
import { TranslationNS } from '@gokrew/models/constants';
import type { ComboBoxOption } from '@/components/ComboBox/ComboBox';

const MONTH_KEYS = ['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december'] as const;

export function useTranslatedMonths(): ComboBoxOption<number>[] {
  const { t } = useTranslation(TranslationNS.LibsCommon);

  return Array.from({ length: 12 }, (_, index) => ({
    value: index + 1,
    label: t(`months.${MONTH_KEYS[index]}`),
  }));
}

export function useTranslatedMonthsAsString(): ComboBoxOption<string>[] {
  const { t } = useTranslation(TranslationNS.LibsCommon);

  return Array.from({ length: 12 }, (_, index) => ({
    value: (index + 1).toString(),
    label: t(`months.${MONTH_KEYS[index]}`),
  }));
}
